import { render, staticRenderFns } from "./DocsPage.vue?vue&type=template&id=00c9e632&scoped=true&"
import script from "./DocsPage.vue?vue&type=script&lang=js&"
export * from "./DocsPage.vue?vue&type=script&lang=js&"
import style0 from "./DocsPage.vue?vue&type=style&index=0&id=00c9e632&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c9e632",
  null
  
)

export default component.exports